import Swiper from 'swiper';

export default () => {
	// const breakpointSettings = {
	// 	breakpoints: {
	// 		1023: {
	// 			slidesPerView: 1,
	// 			coverflowEffect: {
	// 				modifier: 0.2,
	// 				stretch: -200,
	// 			},
	// 		},
	// 	}
	// };

	const coverflowSettings = {
		effect: 'coverflow',
		coverflowEffect: {
			rotate: 0,
			stretch: -150,
			depth: 200,
			modifier: 1,
			slideShadows: false
		},
	};

	const settings = {
		// ...breakpointSettings,
		centeredSlides: true,
		...coverflowSettings,
		grabCursor: true,
		keyboard: {
			enabled: true,
		},
		loop: false,
		speed: 800,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination-container',
			type: 'custom',
			renderCustom: (swiper, current, total) => `${current}/${total}`
		},
		slideShadows: false,
		slidesPerView: 1.75,
		spaceBetween: 20,
		slidesPerGroup: 1,
		loopFillGroupWithBlank: true,
		height: 500,
		roundLengths: true
	};

	const carousel = new Swiper('.swiper-container', settings);

	return carousel;
};
